module.exports = __webpack_public_path__ + "static/ico-mastercard-1d991446c3edcce83e04c4adc47b7466.svg";